import type { Map as MapLibreMap } from "maplibre-gl";
import { ArcLayer } from "./ArcLayer";
export class MapHost {
  private map?: MapLibreMap;
  private disposed = false;
  async mount(container: HTMLElement) {
    const { Map } = await import("maplibre-gl");
    if (this.disposed) return;
    this.map = new Map({ container, center:[0,18], zoom:1.25, attributionControl:false,
      style:{version:8,sources:{},layers:[{id:"background",type:"background",paint:{"background-color":"#081426"}}]} });
    this.map.on("load",()=>this.map?.addLayer(new ArcLayer()));
  }
  resize(){ this.map?.resize(); }
  destroy(){ this.disposed=true; this.map?.remove(); this.map=undefined; }
}
